import { render, staticRenderFns } from "./ProjectCollaboratorNoticeCard.vue?vue&type=template&id=c04c2afc&scoped=true"
import script from "./ProjectCollaboratorNoticeCard.vue?vue&type=script&lang=js"
export * from "./ProjectCollaboratorNoticeCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectCollaboratorNoticeCard.vue?vue&type=style&index=0&id=c04c2afc&prod&lang=scss&scoped=true"
import style1 from "./ProjectCollaboratorNoticeCard.vue?vue&type=style&index=1&id=c04c2afc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18.1_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04c2afc",
  null
  
)

export default component.exports